import { useLazyQuery } from '@apollo/react-hooks';
import { AdSetsWithInsightsQuery, AdSetsWithInsightsQueryVariables } from './__generated__/AdSetsWithInsightsQuery';
import { kmsClient } from 'api';
import { AD_SETS_WITH_INSIGHTS_QUERY } from './adSetsWithInsights.query';

export const useAdSetsWithInsightsLazyQuery = () => {
  return useLazyQuery<AdSetsWithInsightsQuery, AdSetsWithInsightsQueryVariables>(AD_SETS_WITH_INSIGHTS_QUERY, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
